module.exports = __webpack_public_path__ + "img/bg_recom_sch_promo.ba3fe56b.png";